import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';

interface ISkeletonProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 行数
   * @default 3
   */
  rows?: number;
  /**
   * 是否显示头像占位
   * @default false
   */
  avatar?: boolean;
  /**
   * 是否显示标题占位
   * @default false
   */
  title?: boolean;
  /**
   * 是否显示为骨架屏
   * @default true
   */
  loading?: boolean;
  /**
   * 是否开启动画
   * @default true
   */
  animate?: boolean;
  /**
   * 头像风格
   * @default round
   */
  avatarShape?: 'square' | 'round';
}

const Skeleton: FC<PropsWithChildren<ISkeletonProps>> = ({ title = true, avatar = false, rows = 3, loading = true, avatarShape = 'round', animate = true, children }) => {
  const rootCls = classNames('ink-skeleton', { 'ink-skeleton--animate': animate });
  const avatarCls = classNames('ink-skeleton__avatar', { [`ink-skeleton__avatar--${avatarShape}`]: avatarShape });

  return loading ? (
    <View className={rootCls}>
      {avatar && <View className={avatarCls} />}
      <View className="ink-skeleton__content">
        {title && <View className="ink-skeleton__title" />}
        {[...new Array(rows)].map((_item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <View key={index} className="ink-skeleton__row" />
        ))}
      </View>
    </View>
  ) : (
    <>{children}</>
  );
};

export default Skeleton;
